import * as React from "react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <Sonner
      richColors
      theme="light"
      position="top-right"
      visibleToasts={4}
      toastOptions={{
        className:
          "border border-white/10 bg-background/90 text-foreground shadow-2xl backdrop-blur-xl",
        style: {
          zIndex: 9999999999,
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
